module.exports = "fg"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/grid/grid.component.html
// module id = ./src/app/view/grid/grid.component.html
// module chunks = grid.module